module.exports = __webpack_public_path__ + "img/ch81.35d8875c.png";